function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }
function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }
function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }
function _get() { if (typeof Reflect !== "undefined" && Reflect.get) { _get = Reflect.get.bind(); } else { _get = function _get(target, property, receiver) { var base = _superPropBase(target, property); if (!base) return; var desc = Object.getOwnPropertyDescriptor(base, property); if (desc.get) { return desc.get.call(arguments.length < 3 ? target : receiver); } return desc.value; }; } return _get.apply(this, arguments); }
function _superPropBase(object, property) { while (!Object.prototype.hasOwnProperty.call(object, property)) { object = _getPrototypeOf(object); if (object === null) break; } return object; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(arr, i) { var _i = null == arr ? null : "undefined" != typeof Symbol && arr[Symbol.iterator] || arr["@@iterator"]; if (null != _i) { var _s, _e, _x, _r, _arr = [], _n = !0, _d = !1; try { if (_x = (_i = _i.call(arr)).next, 0 === i) { if (Object(_i) !== _i) return; _n = !1; } else for (; !(_n = (_s = _x.call(_i)).done) && (_arr.push(_s.value), _arr.length !== i); _n = !0); } catch (err) { _d = !0, _e = err; } finally { try { if (!_n && null != _i["return"] && (_r = _i["return"](), Object(_r) !== _r)) return; } finally { if (_d) throw _e; } } return _arr; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
import { utils as utils_exports, CONSTANTS as constants_exports, PSVError, AbstractConfigurablePlugin, events as events_exports$1, TypedEvent } from '../core/index.module.js';
import { ObjectLoader, Group, PointLight, AmbientLight, Mesh, MeshLambertMaterial, MeshBasicMaterial, BackSide, MathUtils } from '../../three/build/three.module.js';

/*!
 * PhotoSphereViewer.VirtualTourPlugin 5.1.0
 * @copyright 2023 Damien "Mistic" Sorel
 * @licence MIT (https://opensource.org/licenses/MIT)
 */
var __defProp = Object.defineProperty;
var __export = function __export(target, all) {
  for (var name in all) __defProp(target, name, {
    get: all[name],
    enumerable: true
  });
};

// src/events.ts
var events_exports = {};
__export(events_exports, {
  NodeChangedEvent: function NodeChangedEvent() {
    return _NodeChangedEvent2;
  }
});
var _NodeChangedEvent = /*#__PURE__*/function (_TypedEvent) {
  _inherits(_NodeChangedEvent, _TypedEvent);
  var _super = _createSuper(_NodeChangedEvent);
  function _NodeChangedEvent(node, data) {
    var _this;
    _classCallCheck(this, _NodeChangedEvent);
    _this = _super.call(this, _NodeChangedEvent.type);
    _this.node = node;
    _this.data = data;
    return _this;
  }
  return _createClass(_NodeChangedEvent);
}(TypedEvent);
var _NodeChangedEvent2 = _NodeChangedEvent;
_NodeChangedEvent2.type = "node-changed";

// src/arrow.svg
var arrow_default = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 210 210" x="0px" y="0px"><path fill="currentColor" transform="translate(0 10)" d="M0 181l105 -181 105 181 -105 -61 -105 61zm105 -167l0 99 86 50 -86 -148z"/><!-- Created by Saifurrijal from the Noun Project --></svg>\n';

// src/models/arrow.json
var arrow_default2 = {
  metadata: {
    version: 4.5,
    type: "BufferGeometry",
    generator: "BufferGeometry.toJSON"
  },
  uuid: "8B1A6E5B-A7CC-4471-9CA0-BD64D80ABB79",
  type: "BufferGeometry",
  data: {
    attributes: {
      position: {
        itemSize: 3,
        type: "Float32Array",
        array: [-25, -15, -2.5, 0, 0, -2.5, 0, -5, -2.5, 0, -5, -2.5, 0, 0, -2.5, 25, -15, -2.5, 0, -5, -2.5, 25, -15, -2.5, 25, -20, -2.5, 0, -5, -2.5, -25, -20, -2.5, -25, -15, -2.5, 25, -15, 2.5, 25, -20, 2.5, 25, -15, -2.5, 25, -15, -2.5, 25, -20, 2.5, 25, -20, -2.5, 25, -20, 2.5, 0, -5, 2.5, 25, -20, -2.5, 25, -20, -2.5, 0, -5, 2.5, 0, -5, -2.5, 0, -5, 2.5, -25, -20, 2.5, 0, -5, -2.5, 0, -5, -2.5, -25, -20, 2.5, -25, -20, -2.5, -25, -20, 2.5, -25, -15, 2.5, -25, -20, -2.5, -25, -20, -2.5, -25, -15, 2.5, -25, -15, -2.5, -25, -15, 2.5, 0, 0, 2.5, -25, -15, -2.5, -25, -15, -2.5, 0, 0, 2.5, 0, 0, -2.5, 0, 0, 2.5, 25, -15, 2.5, 0, 0, -2.5, 0, 0, -2.5, 25, -15, 2.5, 25, -15, -2.5, 25, -20, 2.5, 25, -15, 2.5, 0, -5, 2.5, 0, -5, 2.5, 25, -15, 2.5, 0, 0, 2.5, 0, -5, 2.5, 0, 0, 2.5, -25, -15, 2.5, -25, -15, 2.5, -25, -20, 2.5, 0, -5, 2.5],
        normalized: false
      },
      normal: {
        itemSize: 3,
        type: "Float32Array",
        array: [0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -0.514495, -0.857492, 0, -0.514495, -0.857492, 0, -0.514495, -0.857492, 0, -0.514495, -0.857492, 0, -0.514495, -0.857492, 0, -0.514495, -0.857492, 0, 0.514495, -0.857492, 0, 0.514495, -0.857492, 0, 0.514495, -0.857492, 0, 0.514495, -0.857492, 0, 0.514495, -0.857492, 0, 0.514495, -0.857492, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -0.514495, 0.857492, 0, -0.514495, 0.857492, 0, -0.514495, 0.857492, 0, -0.514495, 0.857492, 0, -0.514495, 0.857492, 0, -0.514495, 0.857492, 0, 0.514495, 0.857492, 0, 0.514495, 0.857492, 0, 0.514495, 0.857492, 0, 0.514495, 0.857492, 0, 0.514495, 0.857492, 0, 0.514495, 0.857492, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1],
        normalized: false
      }
    },
    boundingSphere: {
      center: [0, -10, 0],
      radius: 27.041634
    }
  }
};

// src/models/arrow_outline.json
var arrow_outline_default = {
  metadata: {
    version: 4.5,
    type: "BufferGeometry",
    generator: "BufferGeometry.toJSON"
  },
  uuid: "B12A1453-6E56-40AC-840B-BA7DF5DB9E2A",
  type: "BufferGeometry",
  data: {
    attributes: {
      position: {
        itemSize: 3,
        type: "Float32Array",
        array: [-26, -21.766189, -3.5, -26, -14.433809, -3.5, 0, -6.16619, -3.5, 0, -6.16619, -3.5, -26, -14.433809, -3.5, 0, 1.16619, -3.5, 0, -6.16619, -3.5, 0, 1.16619, -3.5, 26, -14.43381, -3.5, 26, -14.43381, -3.5, 26, -21.766191, -3.5, 0, -6.16619, -3.5, -26, -14.433809, 3.5, 0, 1.16619, 3.5, -26, -14.433809, -3.5, -26, -14.433809, -3.5, 0, 1.16619, 3.5, 0, 1.16619, -3.5, 0, 1.16619, 3.5, 26, -14.43381, 3.5, 0, 1.16619, -3.5, 0, 1.16619, -3.5, 26, -14.43381, 3.5, 26, -14.43381, -3.5, 26, -14.43381, 3.5, 26, -21.766191, 3.5, 26, -14.43381, -3.5, 26, -14.43381, -3.5, 26, -21.766191, 3.5, 26, -21.766191, -3.5, 26, -21.766191, 3.5, 0, -6.16619, 3.5, 26, -21.766191, -3.5, 26, -21.766191, -3.5, 0, -6.16619, 3.5, 0, -6.16619, -3.5, 0, -6.16619, 3.5, -26, -21.766189, 3.5, 0, -6.16619, -3.5, 0, -6.16619, -3.5, -26, -21.766189, 3.5, -26, -21.766189, -3.5, -26, -21.766189, 3.5, -26, -14.433809, 3.5, -26, -21.766189, -3.5, -26, -21.766189, -3.5, -26, -14.433809, 3.5, -26, -14.433809, -3.5, -26, -21.766189, 3.5, 0, -6.16619, 3.5, -26, -14.433809, 3.5, -26, -14.433809, 3.5, 0, -6.16619, 3.5, 0, 1.16619, 3.5, 0, 1.16619, 3.5, 0, -6.16619, 3.5, 26, -14.43381, 3.5, 26, -14.43381, 3.5, 0, -6.16619, 3.5, 26, -21.766191, 3.5],
        normalized: false
      },
      normal: {
        itemSize: 3,
        type: "Float32Array",
        array: [0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, -0.514495, 0.857492, 0, -0.514495, 0.857492, 0, -0.514495, 0.857492, 0, -0.514495, 0.857492, 0, -0.514495, 0.857492, 0, -0.514495, 0.857492, 0, 0.514495, 0.857492, 0, 0.514495, 0.857492, 0, 0.514495, 0.857492, 0, 0.514495, 0.857492, 0, 0.514495, 0.857492, 0, 0.514495, 0.857492, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, -0.514495, -0.857492, 0, -0.514495, -0.857492, 0, -0.514495, -0.857492, 0, -0.514495, -0.857492, 0, -0.514495, -0.857492, 0, -0.514495, -0.857492, 0, 0.514495, -0.857492, 0, 0.514495, -0.857492, 0, 0.514495, -0.857492, 0, 0.514495, -0.857492, 0, 0.514495, -0.857492, 0, 0.514495, -0.857492, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, -1, 0, 0, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1, 0, 0, 1],
        normalized: false
      }
    },
    boundingSphere: {
      center: [0, -10.3, 0],
      radius: 28.630814
    }
  }
};

// src/constants.ts
var LINK_DATA = "tourLink";
var DEFAULT_MARKER = {
  html: arrow_default,
  size: {
    width: 80,
    height: 80
  },
  scale: [0.5, 2],
  anchor: "top center",
  className: "psv-virtual-tour__marker",
  style: {
    color: "rgba(0, 208, 255, 0.8)"
  }
};
var DEFAULT_ARROW = {
  color: "#aaaaaa",
  hoverColor: "#aa5500",
  outlineColor: "#000000",
  scale: [0.5, 2]
};
var _ref = function () {
    var loader = new ObjectLoader();
    var geometries = loader.parseGeometries([arrow_default2, arrow_outline_default]);
    var arrow = geometries[arrow_default2.uuid];
    var arrowOutline = geometries[arrow_outline_default.uuid];
    var scale = 0.015;
    var rot = Math.PI / 2;
    arrow.scale(scale, scale, scale);
    arrow.rotateX(rot);
    arrowOutline.scale(scale, scale, scale);
    arrowOutline.rotateX(rot);
    return {
      ARROW_GEOM: arrow,
      ARROW_OUTLINE_GEOM: arrowOutline
    };
  }(),
  ARROW_GEOM = _ref.ARROW_GEOM,
  ARROW_OUTLINE_GEOM = _ref.ARROW_OUTLINE_GEOM;
var AbstractDatasource = /*#__PURE__*/function () {
  function AbstractDatasource(plugin, viewer) {
    _classCallCheck(this, AbstractDatasource);
    this.plugin = plugin;
    this.viewer = viewer;
    this.nodes = {};
  }
  _createClass(AbstractDatasource, [{
    key: "destroy",
    value: function destroy() {}
  }, {
    key: "checkNode",
    value: function checkNode(node) {
      var _node$gps, _node$markers;
      if (!node.id) {
        throw new PSVError("No id given for node");
      }
      if (!node.panorama) {
        throw new PSVError("No panorama provided for node ".concat(node.id));
      }
      if ("position" in node) {
        utils_exports.logWarn('Use the "gps" property to configure the GPS position of a virtual node');
        node.gps = node["position"];
      }
      if (this.plugin.isGps && !(((_node$gps = node.gps) === null || _node$gps === void 0 ? void 0 : _node$gps.length) >= 2)) {
        throw new PSVError("No GPS position provided for node ".concat(node.id));
      }
      if (!this.plugin.isGps && (_node$markers = node.markers) !== null && _node$markers !== void 0 && _node$markers.some(function (marker) {
        return marker.gps && !marker.position;
      })) {
        throw new PSVError("Cannot use GPS positioning for markers in manual mode");
      }
    }
  }, {
    key: "checkLink",
    value: function checkLink(node, link) {
      if (!link.nodeId) {
        throw new PSVError("Link of node ".concat(node.id, " has no target id"));
      }
      if (Array.isArray(link.position)) {
        utils_exports.logWarn('Use the "gps" property to configure the GPS position of a virtual link');
        link.gps = link.position;
        delete link.position;
      }
      if (utils_exports.isExtendedPosition(link)) {
        utils_exports.logWarn('Use the "position" property to configure the position of a virtual link');
        link.position = this.viewer.dataHelper.cleanPosition(link);
      }
      if (!this.plugin.isGps && !utils_exports.isExtendedPosition(link.position)) {
        throw new PSVError("No position provided for link ".concat(link.nodeId, " of node ").concat(node.id));
      }
      if (this.plugin.isGps && !link.gps) {
        throw new PSVError("No GPS position provided for link ".concat(link.nodeId, " of node ").concat(node.id));
      }
    }
  }]);
  return AbstractDatasource;
}();

// src/datasources/ClientSideDatasource.ts
var ClientSideDatasource = /*#__PURE__*/function (_AbstractDatasource) {
  _inherits(ClientSideDatasource, _AbstractDatasource);
  var _super2 = _createSuper(ClientSideDatasource);
  function ClientSideDatasource() {
    _classCallCheck(this, ClientSideDatasource);
    return _super2.apply(this, arguments);
  }
  _createClass(ClientSideDatasource, [{
    key: "loadNode",
    value: function loadNode(nodeId) {
      if (this.nodes[nodeId]) {
        return Promise.resolve(this.nodes[nodeId]);
      } else {
        return Promise.reject(new PSVError("Node ".concat(nodeId, " not found")));
      }
    }
  }, {
    key: "setNodes",
    value: function setNodes(rawNodes) {
      var _this2 = this;
      if (!(rawNodes !== null && rawNodes !== void 0 && rawNodes.length)) {
        throw new PSVError("No nodes provided");
      }
      var nodes = {};
      var linkedNodes = {};
      rawNodes.forEach(function (node) {
        _this2.checkNode(node);
        if (nodes[node.id]) {
          throw new PSVError("Duplicate node ".concat(node.id));
        }
        if (!node.links) {
          utils_exports.logWarn("Node ".concat(node.id, " has no links"));
          node.links = [];
        }
        nodes[node.id] = node;
      });
      rawNodes.forEach(function (node) {
        node.links.forEach(function (link) {
          if (!nodes[link.nodeId]) {
            throw new PSVError("Target node ".concat(link.nodeId, " of node ").concat(node.id, " does not exists"));
          }
          link.gps = link.gps || nodes[link.nodeId].gps;
          link.name = link.name || nodes[link.nodeId].name;
          _this2.checkLink(node, link);
          linkedNodes[link.nodeId] = true;
        });
      });
      rawNodes.forEach(function (node) {
        if (!linkedNodes[node.id]) {
          utils_exports.logWarn("Node ".concat(node.id, " is never linked to"));
        }
      });
      this.nodes = nodes;
    }
  }]);
  return ClientSideDatasource;
}(AbstractDatasource);
var ServerSideDatasource = /*#__PURE__*/function (_AbstractDatasource2) {
  _inherits(ServerSideDatasource, _AbstractDatasource2);
  var _super3 = _createSuper(ServerSideDatasource);
  function ServerSideDatasource(plugin, viewer) {
    var _this3;
    _classCallCheck(this, ServerSideDatasource);
    _this3 = _super3.call(this, plugin, viewer);
    if (!plugin.config.getNode) {
      throw new PSVError("Missing getNode() option.");
    }
    _this3.nodeResolver = plugin.config.getNode;
    return _this3;
  }
  _createClass(ServerSideDatasource, [{
    key: "loadNode",
    value: function loadNode(nodeId) {
      var _this4 = this;
      if (this.nodes[nodeId]) {
        return Promise.resolve(this.nodes[nodeId]);
      } else {
        return Promise.resolve(this.nodeResolver(nodeId)).then(function (node) {
          _this4.checkNode(node);
          if (!node.links) {
            utils_exports.logWarn("Node ".concat(node.id, " has no links"));
            node.links = [];
          }
          node.links.forEach(function (link) {
            if (_this4.nodes[link.nodeId]) {
              link.gps = link.gps || _this4.nodes[link.nodeId].gps;
              link.name = link.name || _this4.nodes[link.nodeId].name;
            }
            _this4.checkLink(node, link);
          });
          _this4.nodes[nodeId] = node;
          return node;
        });
      }
    }
  }]);
  return ServerSideDatasource;
}(AbstractDatasource);
function setMeshColor(mesh, color) {
  mesh.material.color.set(color);
}
function distance(p1, p2) {
  return utils_exports.greatArcDistance(p1, p2) * 6371e3;
}
function bearing(p1, p2) {
  var _p = _slicedToArray(p1, 2),
    long1 = _p[0],
    lat1 = _p[1];
  var _p2 = _slicedToArray(p2, 2),
    long2 = _p2[0],
    lat2 = _p2[1];
  var y = Math.sin(long2 - long1) * Math.cos(lat2);
  var x = Math.cos(lat1) * Math.sin(lat2) - Math.sin(lat1) * Math.cos(lat2) * Math.cos(long2 - long1);
  return Math.atan2(y, x);
}
function gpsToSpherical(gps1, gps2) {
  var _gps1$, _gps2$;
  var p1 = [MathUtils.degToRad(gps1[0]), MathUtils.degToRad(gps1[1])];
  var p2 = [MathUtils.degToRad(gps2[0]), MathUtils.degToRad(gps2[1])];
  var h1 = (_gps1$ = gps1[2]) !== null && _gps1$ !== void 0 ? _gps1$ : 0;
  var h2 = (_gps2$ = gps2[2]) !== null && _gps2$ !== void 0 ? _gps2$ : 0;
  var pitch = 0;
  if (h1 !== h2) {
    pitch = Math.atan((h2 - h1) / distance(p1, p2));
  }
  var yaw = bearing(p1, p2);
  return {
    yaw: yaw,
    pitch: pitch
  };
}

// src/VirtualTourPlugin.ts
var getConfig = utils_exports.getConfigParser({
  dataMode: "client",
  positionMode: "manual",
  renderMode: "3d",
  nodes: null,
  getNode: null,
  startNodeId: null,
  preload: false,
  rotateSpeed: "20rpm",
  transition: constants_exports.DEFAULT_TRANSITION,
  linksOnCompass: true,
  markerStyle: DEFAULT_MARKER,
  arrowStyle: DEFAULT_ARROW,
  markerPitchOffset: -0.1,
  arrowPosition: "bottom"
}, {
  dataMode: function dataMode(_dataMode) {
    if (_dataMode !== "client" && _dataMode !== "server") {
      throw new PSVError("VirtualTourPlugin: invalid dataMode");
    }
    return _dataMode;
  },
  positionMode: function positionMode(_positionMode) {
    if (_positionMode !== "gps" && _positionMode !== "manual") {
      throw new PSVError("VirtualTourPlugin: invalid positionMode");
    }
    return _positionMode;
  },
  renderMode: function renderMode(_renderMode) {
    if (_renderMode !== "3d" && _renderMode !== "markers") {
      throw new PSVError("VirtualTourPlugin: invalid renderMode");
    }
    return _renderMode;
  },
  markerStyle: function markerStyle(_markerStyle, _ref2) {
    var defValue = _ref2.defValue;
    return _objectSpread(_objectSpread({}, defValue), _markerStyle);
  },
  arrowStyle: function arrowStyle(_arrowStyle, _ref3) {
    var defValue = _ref3.defValue;
    return _objectSpread(_objectSpread({}, defValue), _arrowStyle);
  }
});
var VirtualTourPlugin = /*#__PURE__*/function (_AbstractConfigurable) {
  _inherits(VirtualTourPlugin, _AbstractConfigurable);
  var _super4 = _createSuper(VirtualTourPlugin);
  function VirtualTourPlugin(viewer, config) {
    var _this5;
    _classCallCheck(this, VirtualTourPlugin);
    _this5 = _super4.call(this, viewer, config);
    _this5.state = {
      currentNode: null,
      currentTooltip: null,
      loadingNode: null,
      preload: {}
    };
    if (_this5.is3D) {
      _this5.arrowsGroup = new Group();
      var localLight = new PointLight(16777215, 1, 0);
      localLight.position.set(0, _this5.config.arrowPosition === "bottom" ? 2 : -2, 0);
      _this5.arrowsGroup.add(localLight);
    }
    return _this5;
  }
  _createClass(VirtualTourPlugin, [{
    key: "is3D",
    get: function get() {
      return this.config.renderMode === "3d";
    }
  }, {
    key: "isServerSide",
    get: function get() {
      return this.config.dataMode === "server";
    }
  }, {
    key: "isGps",
    get: function get() {
      return this.config.positionMode === "gps";
    }
  }, {
    key: "init",
    value: function init() {
      var _this$markers;
      _get(_getPrototypeOf(VirtualTourPlugin.prototype), "init", this).call(this);
      this.markers = this.viewer.getPlugin("markers");
      this.compass = this.viewer.getPlugin("compass");
      this.gallery = this.viewer.getPlugin("gallery");
      if (!this.is3D && !this.markers) {
        throw new PSVError("VirtualTour plugin requires the Markers plugin in markers mode.");
      }
      if ((_this$markers = this.markers) !== null && _this$markers !== void 0 && _this$markers.config.markers) {
        utils_exports.logWarn("No default markers can be configured on Markers plugin when using VirtualTour plugin. Consider defining `markers` on each tour node.");
        delete this.markers.config.markers;
      }
      this.datasource = this.isServerSide ? new ServerSideDatasource(this, this.viewer) : new ClientSideDatasource(this, this.viewer);
      if (this.is3D) {
        this.viewer.observeObjects(LINK_DATA);
        this.viewer.addEventListener(events_exports$1.PositionUpdatedEvent.type, this);
        this.viewer.addEventListener(events_exports$1.ZoomUpdatedEvent.type, this);
        this.viewer.addEventListener(events_exports$1.ClickEvent.type, this);
        this.viewer.addEventListener(events_exports$1.ObjectEnterEvent.type, this);
        this.viewer.addEventListener(events_exports$1.ObjectHoverEvent.type, this);
        this.viewer.addEventListener(events_exports$1.ObjectLeaveEvent.type, this);
        this.viewer.addEventListener(events_exports$1.ReadyEvent.type, this, {
          once: true
        });
      } else {
        this.markers.addEventListener("select-marker", this);
      }
      if (this.isServerSide) {
        if (this.config.startNodeId) {
          this.setCurrentNode(this.config.startNodeId);
        }
      } else if (this.config.nodes) {
        this.setNodes(this.config.nodes, this.config.startNodeId);
        delete this.config.nodes;
      }
    }
  }, {
    key: "destroy",
    value: function destroy() {
      if (this.markers) {
        this.markers.removeEventListener("select-marker", this);
      }
      if (this.arrowsGroup) {
        this.viewer.renderer.removeObject(this.arrowsGroup);
      }
      this.viewer.removeEventListener(events_exports$1.PositionUpdatedEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ZoomUpdatedEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ClickEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ObjectEnterEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ObjectHoverEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ObjectLeaveEvent.type, this);
      this.viewer.removeEventListener(events_exports$1.ReadyEvent.type, this);
      this.viewer.unobserveObjects(LINK_DATA);
      this.datasource.destroy();
      delete this.datasource;
      delete this.markers;
      delete this.compass;
      delete this.gallery;
      delete this.arrowsGroup;
      _get(_getPrototypeOf(VirtualTourPlugin.prototype), "destroy", this).call(this);
    }
  }, {
    key: "handleEvent",
    value: function handleEvent(e) {
      if (e instanceof events_exports$1.ReadyEvent) {
        this.__positionArrows();
        this.viewer.renderer.addObject(this.arrowsGroup);
        var ambientLight = new AmbientLight(16777215, 1);
        this.viewer.renderer.addObject(ambientLight);
        this.viewer.needsUpdate();
      } else if (e instanceof events_exports$1.PositionUpdatedEvent || e instanceof events_exports$1.ZoomUpdatedEvent) {
        this.__positionArrows();
      } else if (e instanceof events_exports$1.ClickEvent) {
        var _e$data$objects$find;
        var link = (_e$data$objects$find = e.data.objects.find(function (o) {
          return o.userData[LINK_DATA];
        })) === null || _e$data$objects$find === void 0 ? void 0 : _e$data$objects$find.userData[LINK_DATA];
        if (link) {
          this.setCurrentNode(link.nodeId, link);
        }
      } else if (e.type === "select-marker") {
        var _e$marker$data;
        var _link = (_e$marker$data = e.marker.data) === null || _e$marker$data === void 0 ? void 0 : _e$marker$data[LINK_DATA];
        if (_link) {
          this.setCurrentNode(_link.nodeId, _link);
        }
      } else if (e instanceof events_exports$1.ObjectEnterEvent) {
        if (e.userDataKey === LINK_DATA) {
          this.__onEnterObject(e.object, e.viewerPoint);
        }
      } else if (e instanceof events_exports$1.ObjectLeaveEvent) {
        if (e.userDataKey === LINK_DATA) {
          this.__onLeaveObject(e.object);
        }
      } else if (e instanceof events_exports$1.ObjectHoverEvent) {
        if (e.userDataKey === LINK_DATA) {
          this.__onHoverObject(e.viewerPoint);
        }
      }
    }
  }, {
    key: "setNodes",
    value: function setNodes(nodes, startNodeId) {
      var _this6 = this;
      if (this.isServerSide) {
        throw new PSVError("Cannot set nodes in server side mode");
      }
      this.datasource.setNodes(nodes);
      if (!startNodeId) {
        startNodeId = nodes[0].id;
      } else if (!this.datasource.nodes[startNodeId]) {
        startNodeId = nodes[0].id;
        utils_exports.logWarn("startNodeId not found is provided nodes, resetted to ".concat(startNodeId));
      }
      this.setCurrentNode(startNodeId);
      if (this.gallery) {
        this.gallery.setItems(nodes.map(function (node) {
          return {
            id: node.id,
            panorama: node.panorama,
            name: node.name,
            thumbnail: node.thumbnail,
            options: {
              caption: node.caption,
              panoData: node.panoData,
              sphereCorrection: node.sphereCorrection,
              description: node.description
            }
          };
        }), function (id) {
          _this6.setCurrentNode(id);
          _this6.gallery.hide();
        });
      }
    }
  }, {
    key: "setCurrentNode",
    value: function setCurrentNode(nodeId, fromLink) {
      var _this$state$currentNo,
        _this7 = this;
      if (nodeId === ((_this$state$currentNo = this.state.currentNode) === null || _this$state$currentNo === void 0 ? void 0 : _this$state$currentNo.id)) {
        return Promise.resolve(true);
      }
      this.viewer.hideError();
      this.state.loadingNode = nodeId;
      var fromNode = this.state.currentNode;
      var fromLinkPosition = fromNode && fromLink ? this.__getLinkPosition(fromNode, fromLink) : null;
      return Promise.all([Promise.resolve(this.state.preload[nodeId]).then(function () {
        if (_this7.state.loadingNode !== nodeId) {
          throw utils_exports.getAbortError();
        }
        return _this7.datasource.loadNode(nodeId);
      }), Promise.resolve(fromLinkPosition ? this.config.rotateSpeed : false).then(function (speed) {
        if (speed) {
          return _this7.viewer.animate(_objectSpread(_objectSpread({}, fromLinkPosition), {}, {
            speed: speed
          }));
        }
      }).then(function () {
        _this7.viewer.loader.show();
      })]).then(function (_ref4) {
        var _this7$markers, _this7$compass;
        var _ref5 = _slicedToArray(_ref4, 1),
          node = _ref5[0];
        if (_this7.state.loadingNode !== nodeId) {
          throw utils_exports.getAbortError();
        }
        _this7.state.currentNode = node;
        if (_this7.state.currentTooltip) {
          _this7.state.currentTooltip.hide();
          _this7.state.currentTooltip = null;
        }
        if (_this7.is3D) {
          var _this7$arrowsGroup;
          (_this7$arrowsGroup = _this7.arrowsGroup).remove.apply(_this7$arrowsGroup, _toConsumableArray(_this7.arrowsGroup.children.filter(function (o) {
            return o.isMesh;
          })));
        }
        (_this7$markers = _this7.markers) === null || _this7$markers === void 0 ? void 0 : _this7$markers.clearMarkers();
        (_this7$compass = _this7.compass) === null || _this7$compass === void 0 ? void 0 : _this7$compass.clearHotspots();
        return _this7.viewer.setPanorama(node.panorama, {
          transition: _this7.config.transition,
          caption: node.caption,
          description: node.description,
          panoData: node.panoData,
          sphereCorrection: node.sphereCorrection
        }).then(function (completed) {
          if (!completed) {
            throw utils_exports.getAbortError();
          }
        });
      }).then(function () {
        if (_this7.state.loadingNode !== nodeId) {
          throw utils_exports.getAbortError();
        }
        var node = _this7.state.currentNode;
        if (node.markers) {
          if (_this7.markers) {
            _this7.markers.setMarkers(node.markers.map(function (marker) {
              if (marker.gps && _this7.isGps) {
                marker.position = gpsToSpherical(node.gps, marker.gps);
              }
              return marker;
            }));
          } else {
            utils_exports.logWarn("Node ".concat(node.id, " markers ignored because the plugin is not loaded."));
          }
        }
        _this7.__renderLinks(node);
        _this7.__preload(node);
        _this7.dispatchEvent(new _NodeChangedEvent2(node, {
          fromNode: fromNode,
          fromLink: fromLink,
          fromLinkPosition: fromLinkPosition
        }));
        _this7.state.loadingNode = null;
        return true;
      })["catch"](function (err) {
        if (utils_exports.isAbortError(err)) {
          return false;
        }
        _this7.viewer.showError(_this7.viewer.config.lang.loadError);
        _this7.viewer.loader.hide();
        _this7.viewer.navbar.setCaption("");
        _this7.state.loadingNode = null;
        throw err;
      });
    }
  }, {
    key: "__renderLinks",
    value: function __renderLinks(node) {
      var _this8 = this;
      var positions = [];
      node.links.forEach(function (link) {
        var position = _this8.__getLinkPosition(node, link);
        positions.push(position);
        if (_this8.is3D) {
          var _link$arrowStyle, _link$arrowStyle2;
          var mesh = new Mesh(ARROW_GEOM, new MeshLambertMaterial());
          mesh.userData = _defineProperty({}, LINK_DATA, link);
          mesh.rotation.order = "YXZ";
          mesh.rotateY(-position.yaw);
          _this8.viewer.dataHelper.sphericalCoordsToVector3({
            yaw: position.yaw,
            pitch: 0
          }, mesh.position).multiplyScalar(1 / constants_exports.SPHERE_RADIUS);
          var outlineMesh = new Mesh(ARROW_OUTLINE_GEOM, new MeshBasicMaterial({
            side: BackSide
          }));
          outlineMesh.position.copy(mesh.position);
          outlineMesh.rotation.copy(mesh.rotation);
          setMeshColor(mesh, ((_link$arrowStyle = link.arrowStyle) === null || _link$arrowStyle === void 0 ? void 0 : _link$arrowStyle.color) || _this8.config.arrowStyle.color);
          setMeshColor(outlineMesh, ((_link$arrowStyle2 = link.arrowStyle) === null || _link$arrowStyle2 === void 0 ? void 0 : _link$arrowStyle2.outlineColor) || _this8.config.arrowStyle.outlineColor);
          _this8.arrowsGroup.add(mesh);
          _this8.arrowsGroup.add(outlineMesh);
        } else {
          if (_this8.isGps) {
            position.pitch += _this8.config.markerPitchOffset;
          }
          _this8.markers.addMarker(_objectSpread(_objectSpread(_objectSpread({}, _this8.config.markerStyle), link.markerStyle), {}, {
            position: position,
            id: "tour-link-".concat(link.nodeId),
            tooltip: link.name,
            visible: true,
            hideList: true,
            data: _defineProperty({}, LINK_DATA, link)
          }), false);
        }
      });
      if (this.is3D) {
        this.__positionArrows();
      } else {
        this.markers.renderMarkers();
      }
      if (this.config.linksOnCompass && this.compass) {
        this.compass.setHotspots(positions);
      }
    }
  }, {
    key: "__getLinkPosition",
    value: function __getLinkPosition(node, link) {
      if (this.isGps) {
        return gpsToSpherical(node.gps, link.gps);
      } else {
        return this.viewer.dataHelper.cleanPosition(link.position);
      }
    }
  }, {
    key: "__onEnterObject",
    value: function __onEnterObject(mesh, viewerPoint) {
      var _link$arrowStyle3;
      var link = mesh.userData[LINK_DATA];
      setMeshColor(mesh, ((_link$arrowStyle3 = link.arrowStyle) === null || _link$arrowStyle3 === void 0 ? void 0 : _link$arrowStyle3.hoverColor) || this.config.arrowStyle.hoverColor);
      if (link.name) {
        this.state.currentTooltip = this.viewer.createTooltip({
          left: viewerPoint.x,
          top: viewerPoint.y,
          content: link.name
        });
      }
      this.viewer.needsUpdate();
    }
  }, {
    key: "__onHoverObject",
    value: function __onHoverObject(viewerPoint) {
      if (this.state.currentTooltip) {
        this.state.currentTooltip.move({
          left: viewerPoint.x,
          top: viewerPoint.y
        });
      }
    }
  }, {
    key: "__onLeaveObject",
    value: function __onLeaveObject(mesh) {
      var _link$arrowStyle4;
      var link = mesh.userData[LINK_DATA];
      setMeshColor(mesh, ((_link$arrowStyle4 = link.arrowStyle) === null || _link$arrowStyle4 === void 0 ? void 0 : _link$arrowStyle4.color) || this.config.arrowStyle.color);
      if (this.state.currentTooltip) {
        this.state.currentTooltip.hide();
        this.state.currentTooltip = null;
      }
      this.viewer.needsUpdate();
    }
  }, {
    key: "__positionArrows",
    value: function __positionArrows() {
      this.arrowsGroup.position.copy(this.viewer.state.direction).multiplyScalar(0.5);
      var s = this.config.arrowStyle.scale;
      var f = s[1] + (s[0] - s[1]) * (this.viewer.getZoomLevel() / 100);
      var y = 2.5 - this.viewer.getZoomLevel() / 100 * 1.5;
      this.arrowsGroup.position.y += this.config.arrowPosition === "bottom" ? -y : y;
      this.arrowsGroup.scale.set(f, f, f);
    }
  }, {
    key: "__preload",
    value: function __preload(node) {
      var _this9 = this;
      if (!this.config.preload) {
        return;
      }
      this.state.preload[node.id] = true;
      this.state.currentNode.links.filter(function (link) {
        return !_this9.state.preload[link.nodeId];
      }).filter(function (link) {
        if (typeof _this9.config.preload === "function") {
          return _this9.config.preload(_this9.state.currentNode, link);
        } else {
          return true;
        }
      }).forEach(function (link) {
        _this9.state.preload[link.nodeId] = _this9.datasource.loadNode(link.nodeId).then(function (linkNode) {
          return _this9.viewer.textureLoader.preloadPanorama(linkNode.panorama);
        }).then(function () {
          _this9.state.preload[link.nodeId] = true;
        })["catch"](function () {
          delete _this9.state.preload[link.nodeId];
        });
      });
    }
  }]);
  return VirtualTourPlugin;
}(AbstractConfigurablePlugin);
VirtualTourPlugin.id = "virtual-tour";
VirtualTourPlugin.configParser = getConfig;
VirtualTourPlugin.readonlyOptions = Object.keys(getConfig.defaults);
export { VirtualTourPlugin, events_exports as events };
//# sourceMappingURL=index.module.js.map
